<template>
    <div class="box">
        <span class="headline mb24" ref="getheight">奖励配置</span>
        <div class="common mb8" ref="getheight1">通用规则</div>
        <div class="u_shadow mb24" ref="getheight2">
            <span class="u_general_red_envelope_amount">当前奖励金额</span>
            <span class="get_general_red_envelope_amount" @click="getRemarks(wallet_info.general_red_envelope_amount)"
                ><span style="font-size: 16px">￥</span>{{ wallet_info.general_red_envelope_amount }}</span
            >
        </div>
        <div class="Single" ref="getheight3">
            <div class="common">单批次码包规则</div>
            <div class="flexCenter">
                <el-input class="mr12" clearable v-model="page.search_name" @change="changeSearch_name" placeholder="搜索编号"> </el-input>
                <!-- <input
                    class="input-file"
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="exportData"
                /> -->
                <el-button class="input_button" size="mini" @click="leadingin">导入</el-button>
            </div>
        </div>

        <el-table :data="message" :max-height="height + 'px'" style="width: 100%">
            <el-table-column label="导入时间" width="150" :render-header="renderPrice">
                <template slot-scope="scope">
                    {{ scope.row.created_on | formatOrdertime }}
                </template>
            </el-table-column>
            <el-table-column label="编号" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.label_number" placement="bottom">
                        <span class="v_tips">{{ scope.row.label_number }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="quantity" label="二维码数量" :render-header="renderPrice"> </el-table-column>
            <el-table-column label="奖励金额" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.red_envelope_amount" placement="bottom">
                        <span class="v_tips">{{ scope.row.red_envelope_amount | price }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="getBian(scope)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="getExport(scope)">导出</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="通用奖励规则" :visible.sync="resetDialogVisible" width="648px" top="15vh" class="v_dol">
            <el-form :model="numberValidateForm" ref="numberValidateForm">
                <el-form-item
                    prop="general_red_envelope_amount"
                    :rules="[
                        { required: true, message: '金额不能为空' },
                        {
                            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                            message: '请输入合法的金额数字，最多两位小数',
                            trigger: 'change'
                        }
                    ]"
                >
                    <el-input
                        class="el_input"
                        v-model="numberValidateForm.general_red_envelope_amount"
                        clearable
                        placeholder="输入金额"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <!-- <el-button size="mini" @click="resetDialogFalse()">取 消</el-button> -->
                <el-button class="v_buttons" size="mini" @click="resetDialogTrue('numberValidateForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑批次奖励规则" :visible.sync="bianDialogVisible" width="648px" top="15vh" class="v_dol">
            <el-form :model="row" ref="bianValidateForm">
                <el-form-item label="单据编号">
                    <el-input class="el_input" disabled v-model="row.label_number" placeholder="输入单据编号"></el-input>
                </el-form-item>
                <el-form-item
                    label="奖励金额"
                    prop="red_envelope_amount"
                    :rules="[
                        { required: true, message: '金额不能为空' },
                        {
                            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                            message: '请输入合法的金额数字，最多两位小数',
                            trigger: 'change'
                        }
                    ]"
                >
                    <el-input class="el_input" v-model="row.red_envelope_amount" placeholder="输入奖励金额"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <!-- <el-button size="mini" @click="bianClose()">取 消</el-button> -->
                <el-button class="v_buttons" size="mini" @click="bianDialogTrue('bianValidateForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="导入单批次奖励规则" @close="close" :visible.sync="leading" width="648px" top="15vh" class="v_dol">
            <el-upload
                class="upload-demo"
                :limit="1"
                :http-request="btnClick"
                :file-list="fileList"
                action="https://jsonplaceholder.typicode.com/posts/"
                accept=".xls,.XLS,.xlsx,.XLSX"
                drag
            >
                <img src="../../assets/img/Vector.png" alt="" class="Vector" />
                <div class="el-upload__text">点击或拖动上传.excel</div>
                <div class="el-upload__tip" slot="tip">只能上传xls文件，且不超过500kb</div>
            </el-upload>
            <div class="dialog-footer">
                <el-button class="v_buttons" size="mini" @click="getupload">开始上传</el-button>
            </div>
        </el-dialog>
        <div class="notificationn" v-if="notificationns">
            <div class="notificationn_left"></div>
            <div>
                <div class="notificationn_title" v-if="code != 200">导入失败</div>
                <div class="notificationn_dec">{{ msg }}</div>
            </div>
        </div>
        <pagination :page="page" @getPage="getPage" @getNum="getNum"></pagination>
    </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
    name: 'dispose',
    data() {
        return {
   
            msg: '',
            code: 0,
            notificationns: false,
            fileList: [],
            numberValidateForm: {
                general_red_envelope_amount: ''
            },
            page: {
                num: 10,
                page: 1,
                total: 0,
                search_name: '',
                include_wallet_info: 'yes'
            },
            message: [],
            resetDialogVisible: false,
            row: {
                red_envelope_amount: ''
            },
            index: -1,
            bianDialogVisible: false,
            leading: false,
            red_packet: {},
            arr: {},
            height: '',
            wallet_info: {} //通用奖励规则  balance 余额 general_red_envelope_amount通用奖励金额 failed_red_envelope_amount审核失败用户获得奖励金额
        };
    },
    mounted() {
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
        this.height =
            this.screenHeight -
            this.$refs.getheight.offsetHeight -
            this.$refs.getheight1.offsetHeight -
            this.$refs.getheight2.offsetHeight -
            this.$refs.getheight3.offsetHeight -128
            // 85 -
            // 24 -
            // 8 -
            // 24 -
            // 14 -
            // 40;
            // 59+24+8+24+14
        this.getMessage(); //获取列表
    },
    methods: {
        renderPrice(h, { column, $index }) {
            const styleFilter = {
                fontSize: '16px',
                fontWeight: 'bold',
                marginLeft: '8px'
            };
            return [
                column.label,
                h(
                    'i',
                    [
                        h('span', {
                            class: { 'el-icon-bottom': true },
                            style: {
                                ...styleFilter //设置样式
                            }
                        })
                    ] // 图标
                )
            ];
        },
        getMessage() {
            let that = this;
            let obj = {
                page: that.page.page,
                num: that.page.num,
                include_wallet_info: that.page.include_wallet_info
            };
            if (that.page.search_name) {
                obj.search_name = that.page.search_name;
            }
            that.$get('/backapi/red_packet_config', obj).then(function (res) {
                console.log(res);

                if (res.count) {
                    that.page.total = res.data.single_label_packet_rule.length;
                    that.message = res.data.single_label_packet_rule;
                    that.wallet_info = res.data.wallet_info;
                } else {
                    that.page.total = 0;
                    that.message = [];
                }
            });
        },
        getPage(e) {
            this.page.page = e;
            this.getMessage();
        },
        getNum(e) {
            this.page.num = e;
            this.page.page = 1;
            this.getMessage();
        },
        // 搜索编号
        changeSearch_name(e) {
                this.page.search_name = e;
           
                this.page.num = 10;
                this.page.page = 1;
            this.getMessage(); //获取列表
        },
        //通用规则修改
        getRemarks(e) {
            this.numberValidateForm.general_red_envelope_amount = e;
            this.resetDialogVisible = true;
        },
        resetDialogFalse() {
            this.numberValidateForm.general_red_envelope_amount = '';
            this.resetDialogVisible = false;
        },
        resetDialogTrue(formName) {
            let that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let obj = {
                        general_red_envelope_amount: Number(that.numberValidateForm.general_red_envelope_amount)
                    };
                    that.$post('/backapi/update_wallet', obj).then(function (res) {
                        that.wallet_info.general_red_envelope_amount = that.numberValidateForm.general_red_envelope_amount;
                        that.msg = '修改成功';
                        that.code=res.code
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                        that.resetDialogFalse();
                        that.getMessage();
                    });
                } else {
                    return false;
                }
            });
        },
        // 编辑
        getBian(e) {
            this.row = JSON.parse(JSON.stringify(e.row));
            this.index = e.$index;
            this.bianDialogVisible = true;
        },
        bianClose() {
            this.row = {};
            this.index = -1;
          
            this.bianDialogVisible = false;
        },
        bianDialogTrue(formName) {
            let that = this;
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    let obj = {
                        id: that.row.id,
                        red_envelope_amount: that.row.red_envelope_amount
                    };
                    that.$put('/backapi/red_packet_config', obj).then(function (res) {
                        that.message[that.index].red_envelope_amount = that.row.red_envelope_amount;
                        // that.$message({
                        //     message: '修改成功',
                        //     type: 'success'
                        // });
                        console.log(res);
                        that.msg = '修改成功';
                        that.code=res.code
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                            that.code=0
                        }, 3000);
                        that.bianClose();
                        // that.getMessage();
                    });
                } else {
                    return false;
                }
            });
        },
        // 导入
        leadingin() {
            this.code=0
            this.msg=''
            this.leading = true;
        },
        // 关闭
        close() {
            this.leading = false;
            this.fileList = [];
            this.arr = {};
            // this.msg=''
            // this.code=0

        },
        handleChange(file, fileList) {
            this.fileList = fileList;
        },
        btnClick(event) {
            let file = event.file; // 拿到文件信息
            if (!file) {
                return false;
            } else if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
                // 这里格式根据自己需求定义
                this.$message.error('格式错误，请上传xls或者xlsx格式');
                return false;
            }
            const fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    const data = ev.target.result;
                    const workbook = XLSX.read(data, {
                        // 以字符编码方式解析
                        type: 'binary'
                    });
                    // 获取第一张表
                    const exlname = workbook.SheetNames[0];
                    const exl = XLSX.utils.sheet_to_json(workbook.Sheets[exlname]); // 生成json表格内容
                    let label_list_str = [];
                    exl.map((item) => {
                        if (item.溯源码) {
                            label_list_str.push(item.溯源码);
                        }
                    });
                    let obj = {
                        label_number: exl[0].订单编号 ? exl[0].订单编号 : '',
                        red_envelope_amount: exl[0].奖励金额 ? exl[0].奖励金额 : 0,
                        label_list_str: label_list_str ? label_list_str : []
                    };
                    this.red_packet = obj;
                    this.getPick();
                } catch (e) {
                    return false;
                }
            };
            fileReader.readAsBinaryString(file);
        },
        getPick() {
            let that = this;
        
            if (that.red_packet.label_list_str.length == 0) {
                that.close();
                that.notificationns = true;
                setTimeout(() => {
                    that.notificationns = false;
                }, 3000);
                return;
            }
            const newArr = that.red_packet.label_list_str.map((item) => item);
            const str = newArr.join(',') + ',';
            const flag = newArr.some((item) => {
                return str.replace(item + ',', '').indexOf(item + ',') > -1;
            });
            if (flag) {
                that.msg = '出现重复导入';
                that.close();
                that.notificationns = true;
                setTimeout(() => {
                    that.notificationns = false;
                }, 3000);
                return;
            }
            let obj = {
                label_number: that.red_packet.label_number,
                red_envelope_amount: that.red_packet.red_envelope_amount,
                label_list_str: []
            };
            if (obj.label_number == '') {
                that.msg = '请上传订单编号';
                that.close();
                that.notificationns = true;
                setTimeout(() => {
                    that.notificationns = false;
                }, 3000);
                return;
            }
            if (obj.red_envelope_amount < 0.3) {
                that.msg = '金额需大于0.3元';
                that.close();
                that.notificationns = true;
                setTimeout(() => {
                    that.notificationns = false;
                }, 3000);
                return;
            }

            that.red_packet.label_list_str.map((item) => {
                // obj.label_list_str.push(that.$parseParmStr(item).id);
                obj.label_list_str.push(item.toString());
            });
            that.arr = obj;
        },
        // 上传
        getupload() {
            let that = this;
            if (that.red_packet.length == 0) {
                that.$message.error({
                    message: '请上传文件'
                });
                return;
            }
            let obj = {
                label_number: that.arr.label_number,
                red_envelope_amount: that.arr.red_envelope_amount,
                label_list_str: JSON.stringify(that.arr.label_list_str)
            };
            that.$post('/backapi/red_packet_config', obj)
                .then(function (res) {
                    console.log(res);
                    if (res.code == 200) {
                        that.code = res.code;
                        that.msg = '导入成功';
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                        that.getMessage();
                        that.close();
                    } else {
                        that.msg = res.msg;
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                        that.close();
                    }
                })
                .catch((err) => {
                    that.close();
                });
        },
        // 导出
        getExport(e) {
            let that = this;

            let row = JSON.parse(JSON.stringify(e.row));
            const fdArray = [];
            var obj = {
                导入时间: that.$formatOrdertime(row.created_on),
                编号: row.label_number,
                二维码数量: row.quantity,
                奖励金额: row.red_envelope_amount
            };
            fdArray.push(obj);
            var wb = XLSX.utils.book_new();
            let sheet = XLSX.utils.json_to_sheet(fdArray);
            sheet['!cols'] = [{ wch: 20 }, { wch: 30 }, { wch: 20 }, { wch: 20 }];
            XLSX.utils.book_append_sheet(wb, sheet, 'sheet', { raw: true });
            XLSX.writeFile(wb, '奖励配置 - 数据' + '.xlsx');
            that.msg = '数据导出成功';
            that.code=200
            that.notificationns = true;
            setTimeout(() => {
                that.notificationns = false;
            }, 3000);
            // that.$message({
            //     message: '数据导出成功',
            //     type: 'success'
            // });
        }
    }
};
</script>

<style scoped>
.el-upload__tip {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;

    color: #697077;
}
.Vector {
    width: 93px;
    height: 60px;
    margin: 32px 0 9px 0;
}
/deep/.el-upload--text {
    width: 100%;
    height: 193px;
    border: none;
}
/deep/.el-upload-dragger {
    width: 100%;
    height: 193px;
}

.v_buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 162px;
    height: 48px;
    background: #91d9f2;
    border: 2px solid #91d9f2;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ffffff;
}

/deep/ .v_dol .el-dialog {
    background: #ffffff;
    padding: 24px;
    border: 1px solid #dde1e6;
    border-radius: 16px;
}

/deep/.v_dol .el-dialog .el-dialog__header {
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/.v_dol .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/.v_dol .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.v_dol .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/.v_dol .el-dialog__body {
    padding: 0;
}
/deep/.v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}
/deep/.el-table thead {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #121619;
}
/deep/.el-table {
    font-weight: 400;
    font-size: 12px;
    color: #121619;
}
/deep/.el-table .el-table__cell {
    border: none;
}
.mr12 {
    margin-right: 12px;
}
/deep/.flexCenter .el-input {
    width: 387px;
}
/deep/ el-input::-webkit-input-placeholder {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ababab;
}
/deep/.flexCenter .el-input .el-input__inner {
    background: #ffffff;
    border: 1px solid #16307c;
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    color: #121619;
    width: 100%;
    height: 35px;
    background: url('../../assets/img/search-outline.png') no-repeat 8px center;
    background-size: 24px;
    padding-left: 40px;
}
.Single {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
}
.mb24 {
    margin-bottom: 24px;
    display: inline-block;
}
.mb8 {
    margin-bottom: 8px;
}
.common {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;

    color: #333333;
}
.u_shadow {
    width: 329px;
    padding: 20px 16px;
    background: #ffffff;
    box-shadow: 1px 3px 8px rgba(22, 48, 124, 0.16);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
}
.u_general_red_envelope_amount {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    /* identical to box height, or 16px */

    letter-spacing: 0.005em;

    color: #333333;
    margin-bottom: 16px;
}
.get_general_red_envelope_amount {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 100%;
    letter-spacing: 0.01em;
    color: #333333;
    text-align: right;
}
.input-file {
    display: none;
}
</style>
